import * as React from 'react';
import { FabricSize } from '../../../UIData/_data/Fabrics';
import { UserPatternStore } from '../../../UserData/_stores/UserPatternsStore';

export type Props = {
	src: string
	size: FabricSize
	pattern: UserPatternStore
	length: number
}

const RULER_SIZE:number = 25;
const RENDER_SCALE:number = 15;
const RENDER_WIDTH:number = 108;
const RENDER_HEIGHT:number = 39;

export default function PatternPreview(props: Props) {
	const canvas = React.useRef<HTMLCanvasElement>(null);
	const [context, setContext] = React.useState(null as CanvasRenderingContext2D)

	const imagesLoaded = () => {
		return image.complete && rulers.complete
	}

	const onImageLoad = () => {
		if (imagesLoaded()) {
			updatePreview()
		}
	}

	let [image, rulers] = [document.createElement('img'), document.createElement('img')]
	image.onload = onImageLoad
	rulers.onload = onImageLoad
	image.src = props.src
	rulers.src = '/static/img/cart/rulers.png'

	React.useEffect(() => {
		updatePreview()
	}, [props.size, props.pattern, props.length, context])

	React.useEffect(() => {
		setContext(canvas.current.getContext('2d'))
	}, [canvas])

	const updatePreview = () => {
		if(!context || !imagesLoaded()) return;
		context.clearRect(0, 0, canvas.current.width, canvas.current.height);

		const patternWidth = props.pattern.get('width')
		const patternHeight = props.pattern.get('height')
		const repeatMode = props.pattern.get('repeatMode')

		let width = 0;
		let height = 0;

		const ratio = patternWidth / patternHeight;

		const scale = 150 / RENDER_SCALE;

		if(ratio > 1) {
			width = 768;
			height = 768 / ratio;
		} else {
			height = 768;
			width = 768 * ratio;
		}

		const drawParams:[number, number, number, number, number, number, number, number] = [
			(1024 - width) / 2,
			(1024 - height) / 2,
			width,
			height,
			0,
			0,
			patternWidth / scale,
			patternHeight / scale
		];

		const offscreen = document.createElement('canvas')
		offscreen.width = patternWidth / scale
		offscreen.height = patternHeight / scale
		const offscreenCtx = offscreen.getContext('2d')
		try {
			offscreenCtx.drawImage(image, ...drawParams)
		} catch(e) {
			//This will happen if image is broken
		}

		switch (repeatMode) {
			case "tile":
				context.translate(RULER_SIZE, RULER_SIZE)
				const pattern = context.createPattern(offscreen, "repeat")
				context.fillStyle = pattern
				context.fillRect(0, 0, props.size.get('width') * RENDER_SCALE, props.size.get('height') * props.length * RENDER_SCALE)
				context.translate(-RULER_SIZE, -RULER_SIZE)
			break
			case "panel":
				context.fillStyle = "#FFFFFF"
				context.fillRect(0, 0, canvas.current.width, canvas.current.height)
				const [cx, cy] = [(canvas.current.width - RULER_SIZE) / 2 + RULER_SIZE, (canvas.current.height - RULER_SIZE) / 2 + RULER_SIZE]
				
				let [x, y] = [cx - (offscreen.width / 2), cy - (offscreen.height / 2)]

				x = Math.max(x, RULER_SIZE)
				y = Math.max(y, RULER_SIZE)

				context.drawImage(offscreen, x, y)				
		}
		
		context.drawImage(rulers, 0, 0, RENDER_WIDTH * RENDER_SCALE + RULER_SIZE, RENDER_HEIGHT * RENDER_SCALE + RULER_SIZE)

		for (let i = 1; i < props.length; i++) {
			context.drawImage(
				rulers, 
				0,
				0,
				RULER_SIZE,
				RENDER_HEIGHT * RENDER_SCALE,
				0, 
				i * (RENDER_HEIGHT * RENDER_SCALE + RULER_SIZE), 
				RULER_SIZE, 
				RENDER_HEIGHT * RENDER_SCALE + RULER_SIZE,
			);	
		}
	}

	return <canvas 
		width={props.size.get('width') * RENDER_SCALE + RULER_SIZE} 
		height={RENDER_HEIGHT * RENDER_SCALE * props.length + RULER_SIZE} 
		ref={canvas} 
	/>
}